// Module
var code = "<div ng-if=\"ctrl.navModel\">\n  <page-header model=\"ctrl.navModel\"></page-header>\n\n  <div class=\"page-container\">\n    <div ng-if=\"ctrl.page\">\n      <plugin-component type=\"app-page\">\n      </plugin-component>\n    </div>\n  </div>\n</div>\n\n<footer>\n";
// Exports
var _module_exports =code;;
var path = 'public/app/features/plugins/partials/plugin_page.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;